export default __webpack_public_path__ + "static/Minipax-SemiBold-197dbd9a4e55d8887fed694396ed7771.woff";